import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { key } from './config';

const List = lazy(() => import('./index'));
const Create = lazy(() => import('./create'));
const Update = lazy(() => import('./update'));

export default function ApprovalAuthorityRoutes() {
  return (
    <Route path={key}>
      <Route index element={<List />} />
      <Route path="create" element={<Create />} />
      <Route path=":id/update" element={<Update />} />
    </Route>
  );
}
